import { useState } from 'react';
import { Carousel } from '@mantine/carousel';
import {
  BackgroundImage,
  Container,
  Title,
  Text,
  createStyles,
  Anchor,
} from '@mantine/core';
import style from './cardDekstopStyle.module.css';

const useStyles = createStyles((theme) => ({
  backgroundImage: {
    height: '100%',
    borderRadius: '20px!important',
  },
  containerText: {
    width: 200,
    paddingTop: '150%',
  },
  control: {
    backgroundColor: '#F2EEC8',
    color: '#F56600',
    borderColor: '#F2EEC8',
    opacity: 1,
  },
  anchor: {
    '&:hover': {
      color: theme.white,
      textDecoration: 'none',
    },
  },
  title: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 700,
    fontSize: 18,
  },
}));

const CardDekstopCompo = (props) => {
  const { classes } = useStyles();
  return (
    <>
      <Carousel.Slide mr={20}>
        <Anchor href="/#" key={props.key} className={classes.anchor}>
          <BackgroundImage
            src={`'${props.image} '`}
            className={classes.backgroundImage}
          >
            <Container
              className={`${classes.containerText} ${style.textContainer}`}
            >
              <Title className={`${style.title} ${classes.title}`}>
                {props.title}
              </Title>
              <Text>{props.address}</Text>
            </Container>
          </BackgroundImage>
        </Anchor>
      </Carousel.Slide>
    </>
  );
};
export default CardDekstopCompo;
